export default __webpack_public_path__ + "static/media/pvilla6-1.8e049e27.webp";